export const STORAGE_KEYS = {
  DEEPSEEK_NOTIFICATION: 'deepseek-notification-dismissed',
} as const;
